import React from "react";

import MarketingLink from "@/components/common/LinkHandler/MarketingLink";
import { TextElementMen } from "@/components/ui-kit/TextElementMen/TextElementMen";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import UserContext from "@/context/UserContext";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

import styles from "./Footer.module.scss";

type Props = {
  type: string;
  theme: ThemeTypes;
};

const text = "Log in to your myNutrafol account";

export const FooterLogin: React.FC<Props> = ({ type, theme }) => (
  <UserContext.Consumer>
    {(userState) => (
      <>
        {!userState.isLoggedIn ? (
          <div className={cn(styles.loginBox, type)}>
            <TextElementNova
              text="Already a customer?"
              element="p"
              className="Body-20-Dia-Strong"
            />
            <MarketingLink path="/customer/account/login/">
              {(() => {
                const TextComponent = theme === "men" ? TextElementMen : TextElementNova;
                const fontClass = theme === "men" ? "CTA-20-Dia-Mono" : "CTA-20-Dia-Normal";

                return (
                  <TextComponent
                    text={text}
                    element="span"
                    className={cn(
                      "text-nova-base-white underline underline-offset-4 !text-[14px]",
                      fontClass
                    )}
                  />
                );
              })()}
            </MarketingLink>
          </div>
        ) : null}
      </>
    )}
  </UserContext.Consumer>
);
